import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { SearchBarTable } from 'hljd'
import getColumns from './columns'

@observer
export default class extends Component {
  componentDidMount() {
    this.props.store.setStoreData('tableForceUpdate', () => this.forceUpdate())
  }
  render() {
    return (
      <SearchBarTable
        store={this.props.store}
        columns={getColumns(this.props.store)}
        style={{ marginTop: 20 }}
      />
    )
  }
}
